<script setup lang="ts">
    const id = useId()
    const props = defineProps<{
        modelValue?: number
        label?: string
        min?: number | string
        max?: number | string
        step?: number | string
        name?: string
        defaultValue?: number | string
    }>()

    const emit = defineEmits<{
        'update:modelValue': [number]
    }>()

    const modelValue = computed({
        get: () => props.modelValue,
        set: (value: string) => {
            emit('update:modelValue', parseFloat(value))
        },
    })

    onMounted(() => {
        if (
            props.modelValue === undefined &&
            props.defaultValue !== undefined
        ) {
            emit('update:modelValue', parseFloat(props.defaultValue.toString()))
        }
    })
</script>

<template>
    <div>
        <label v-if="label" :for="id" class="block text-12 text-word-3 mb-2">
            {{ label }}
        </label>
        <div class="flex gap-sm items-center">
            <input
                :id="id"
                v-model="modelValue"
                type="range"
                :name
                :min
                :max
                :step
                class="flex-1 bg-word text-word appearance-none rounded-full h-2" />
            <div
                class="text-14 bg-surface border border-surface-3 rounded-md p-4 text-center w-36">
                {{ modelValue ? $n(parseFloat(modelValue.toString())) : '-' }}
            </div>
        </div>
    </div>
</template>
